import React, {useEffect, useState} from 'react'
import {useQuery} from '@tanstack/react-query'
import {QUERIES, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {ListLoading, NoData} from '../../../../_component/ListLoading'
import {DefaultTitle} from '../_components/DefaultTitle'
import {Link, useLocation, useSearchParams} from 'react-router-dom'
import {getProfiles} from '../../../modules/accounts/core/_requests'
import {ListPagination, PaginationState} from '../_components/ListPagination'
import {useThemeMode} from '../../../../_metronic/partials'
import {StaticRating} from '../../../../_component/Rating'
import {truncateString} from '../../../../_component/CustomFunctions'

const StylistListPage = () => {
  const {mode} = useThemeMode()
  const [state, setState] = useState<PaginationState>({page_number: 1, page_size: 9})
  const location = useLocation()
  const catalogue_url = location.pathname.replace('staffs', 'services')
  const [filter, setFilter] = useState<any>({status: true})
  const [searchParams] = useSearchParams()
  const service_id = searchParams.get('service_id')
  useEffect(() => {
    if (service_id) setFilter({...filter, service_id})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service_id])
  const {isFetching, data} = useQuery(
    [
      `${QUERIES.PROFILES_LIST}-page_number=${state.page_number}&page_size=${
        state.page_size
      }&filter=${JSON.stringify(filter)}`,
    ],
    () => {
      let query = `page_number=${state.page_number}&page_size=${
        state.page_size
      }&filter=${JSON.stringify(filter)}`
      return getProfiles(query)
    },
    {keepPreviousData: true}
  )
  useEffect(() => {
    if (data) setState({...state, total: data.total_count, count: data.entities?.length})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  const updateState = (data: any) => {
    setState({...state, ...data})
  }
  return (
    <>
      {isFetching && <ListLoading />}
      {!isFetching && !data?.entities?.length && <NoData />}
      {/* end::Container */}
      <div className='d-flex flex-column flex-column-fluid'>
        <DefaultTitle title='Stylists List' filter={filter} setFilter={setFilter} />
        {/*begin::Container*/}
        <div className='container'>
          {/*begin::Row*/}
          <div className='row mb-5'>
            {/*begin::Col*/}
            {data?.entities?.map(
              (entity, i) =>
                entity?.about && (
                  <div key={i} className='col-xl-4 col-lg-6 col-md-6 col-sm-6'>
                    {/*begin::Card*/}
                    <div className='card card-custom gutter-b card-stretch'>
                      {/*begin::Body*/}
                      <div className='card-body pt-4'>
                        {/*begin::User*/}
                        <div className='d-flex align-items-center mb-7'>
                          {/*begin::Pic*/}
                          <div className='flex-shrink-0 me-4 mt-lg-0 mt-3'>
                            <div className={`symbol symbol-circle symbol-lg-75px`}>
                              <img
                                src={
                                  entity.image_url
                                    ? process.env.REACT_APP_BUCKET_URL + '/'! + entity.image_url
                                    : toAbsoluteUrl(
                                        `/media/svg/avatars/blank${
                                          mode === 'dark' ? '-dark' : ''
                                        }.svg`
                                      )
                                }
                                alt='image_url'
                              />
                            </div>
                          </div>
                          {/*end::Pic*/}
                          {/*begin::Title*/}
                          <div className='d-flex flex-column'>
                            <span className='text-dark fw-bold text-hover-primary fs-4 mb-0 text-capitalize'>
                              {truncateString(entity.name!, 25)}
                            </span>
                            <span className='text-muted fw-bold text-capitalize'>
                              {entity.title}
                            </span>
                          </div>
                          {/*end::Title*/}
                        </div>
                        {/*end::User*/}
                        {/*begin::Desc*/}
                        <p className='mb-7' style={{textAlign: 'justify'}}>
                          {entity.about}
                        </p>
                        {/*end::Desc*/}
                        {/*begin::Info*/}
                        <div className='mb-7'>
                          {/* <div className='d-flex justify-content-between align-items-center'>
                            <span className='text-dark-75 fw-bolder me-2'>Email:</span>
                            <a
                              href={`mailto:${entity.email}`}
                              className='text-muted text-hover-primary'
                            >
                              {entity.email}
                            </a>
                          </div>
                          <div className='d-flex justify-content-between align-items-center'>
                            <span className='text-dark-75 fw-bolder me-2'>Phone Number:</span>
                            <a
                              href={`tel:${entity.phone}`}
                              className='text-muted text-hover-primary'
                            >
                              {entity.phone}
                            </a>
                          </div> */}
                          <div className='d-flex justify-content-between align-items-center'>
                            <span className='text-dark-75 fw-bolder me-2'>Rating:</span>
                            <span className='text-muted'>
                              <StaticRating value={entity.rating || 0} />
                            </span>
                          </div>
                        </div>
                        {/*end::Info*/}
                        <div className='d-grid gap-2'>
                          <Link
                            className='btn btn-block btn-sm btn-light-primary fw-bolder text-uppercase py-4'
                            to={catalogue_url + '?staff_id=' + entity.id}
                          >
                            View Catalogue
                          </Link>
                          <Link
                            to={'/' + location.pathname.split('/')[1] + '?staff_id=' + entity.id}
                            className='btn btn-block btn-sm btn-light-primary fw-bolder text-uppercase py-4'
                            // onClick={() => setShow(entity.user_id)}
                          >
                            Make an Appointment
                          </Link>
                        </div>
                      </div>
                      {/*end::Body*/}
                    </div>
                    {/*end::Card*/}
                  </div>
                )
            )}
            {/*end::Col*/}
          </div>
          {data?.entities?.length ? (
            <ListPagination isLoading={isFetching} updateState={updateState} pagination={state} />
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  )
}
export default StylistListPage
